import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Traveler } from './../../shared/models';
import { State, SelectItem } from '@bhtp-client-api/eligibility';
import { TravelerDetailViewConfig } from '@bhtp-client-web/component';

@Component({
    selector: 'additional-traveler-list',
    template: require('./additional-traveler-list.component.html'),
    styles: [`
        .additional-traveler-row {
            background-color: #f9f9f9;
            border: 1px solid #e4e4e4;
            padding-top: 5px;
            padding-bottom: 5px;
            margin-bottom: 5px;
        }
    `]
})
export class AdditionalTravelerListComponent {
    @Input() public additionalTravelers: Traveler[];
    @Input() public additionalTravelerForms: FormArray;
    @Input() public additionalTravelerConfig: TravelerDetailViewConfig;
    @Input() public maxTravelers: number;
    @Input() public states: State[];
    @Input() public submitted: boolean;
    @Input() public enableAddTraveler: boolean = true;

    public get showAdditionalTravelers(): boolean {
        return this.additionalTravelers ? this.additionalTravelers.length > 0 : false;
    }

    public get canAddTraveler(): boolean {
        return this.enableAddTraveler && this.additionalTravelers && this.maxTravelers ?
            this.additionalTravelers.length < (this.maxTravelers - 1) :
            false;
    }

    protected onAddTravelerClick(event: any): void {
        if (this.canAddTraveler) {
            this.additionalTravelers.push(new Traveler(false));
            this.additionalTravelerForms.push(new FormGroup({ }));
        }
    }

    protected onRemoveTravelerClick(event: any, index: number): void {
        this.additionalTravelers.splice(index, 1);
        this.additionalTravelerForms.removeAt(index);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/traveler/additional-traveler-list.component.ts